import React from 'react';
import Loadable from 'react-loadable';
import { once } from 'lodash';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader';
import { CookiesProvider } from 'react-cookie';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import {
  createSplitFilter,
  setWavetrakFeatureFrameworkCB,
  setWavetrakSplitFilters,
  getWavetrakSplitFilters,
} from '@surfline/web-common';

import createStore from '../stores';
import * as treatments from '../common/treatments';

import '@surfline/quiver-themes/stylesheets/normalize.css';
import '../styles/base.scss';
import { setupLogRocket } from '../utils/setupLogRocket';
import setNewRelicErrorHandler from '../utils/setNewRelicErrorHandler';

const root = document.querySelector('#root');

const preloadedState = window.__DATA__; // eslint-disable-line no-underscore-dangle

const history = createBrowserHistory();

// Create a history of your choosing (we're using a browser history in this case)
const store = createStore(preloadedState, history);

window.wavetrakStore = store;

setNewRelicErrorHandler();

const doHydrate = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const Routes = hot(module)(require('../components/Routes').default);

  Loadable.preloadReady().then(() => {
    hydrate(
      <CookiesProvider>
        <Provider store={store}>
          <ConnectedRouter history={history} noInitialPop>
            <Routes />
          </ConnectedRouter>
        </Provider>
      </CookiesProvider>,
      root,
    );
  });
};

setWavetrakFeatureFrameworkCB(
  once(() => {
    setupLogRocket(store);
    doHydrate();
  }),
);

const mount = async () => {
  try {
    // Get the list on enabled splits and create the list of treatment names to load
    const splitFilters = createSplitFilter(treatments);

    const quiverTreatments = window.quiverTreatments || [];

    // Set the treatment names on the window so that backplane can access them
    setWavetrakSplitFilters([...splitFilters, ...quiverTreatments, ...getWavetrakSplitFilters()]);
  } catch (error) {
    window.newrelic?.noticeError(error);
  }
};

mount();

if (module.hot) {
  module.hot.accept('../components/Routes', () => {
    unmountComponentAtNode(root);
    doHydrate();
  });
}
